import { useState } from 'react';
import { useAuth } from '../../context/useAuth';
import { openFoodModule, getFoodUserDestPath } from '../../utils/foodModule';
import { isCoachFoodOperator, userRoles } from './roles';

/**
 * Panel FOOD en shell: abre Nest embebido en /food-plan (SSO).
 * Superadmin → Maestros Nest (/superadmin). Coach → /trainer.
 */
export default function FoodPlanAdminView({ onBack, onNavigate }) {
  const { user } = useAuth();
  const [foodLoading, setFoodLoading] = useState(false);
  const [error, setError] = useState('');
  const coachPanel = isCoachFoodOperator(user);
  const roles = userRoles(user);
  const isSuper = roles.includes('super_admin');
  const canFoodFinance = isSuper || roles.includes('admin_food') || roles.includes('admin_food_plan');

  const handleOpenFood = async () => {
    setFoodLoading(true);
    setError('');
    const dest = getFoodUserDestPath(user);
    const result = await openFoodModule(dest, { user, coach: coachPanel });
    if (!result?.ok && !result?.redirecting) {
      setError(result?.error || 'No se pudo abrir FOOD PLAN');
    }
    setFoodLoading(false);
  };

  return (
    <div className="dashboard-main-view surface-readable training-light-island p-6 max-w-xl rounded-xl border border-slate-200">
      <button type="button" className="btn-secondary text-sm mb-4" onClick={onBack}>
        ← Volver
      </button>
      <h3 className="text-xl font-bold text-stone-900 mb-2">FOOD PLAN</h3>
      <p className="text-stone-600 mb-4">
        {isSuper
          ? 'Administración FOOD (usuarios, planes, catálogo, seguimiento) dentro del ecosistema — misma app Nest embebida en /food. Los reportes de este panel son solo FOOD, no D28D ni Training.'
          : coachPanel
            ? 'Abre el panel de entrenador FOOD dentro del ecosistema (Nest en /food).'
            : 'Abre FOOD PLAN dentro del ecosistema en /food.'}
      </p>
      {error ? <p className="text-sm text-red-600 mb-3">{error}</p> : null}
      <div className="flex flex-col gap-2">
        <button type="button" className="food-external-cta" disabled={foodLoading} onClick={handleOpenFood}>
          {foodLoading ? 'Conectando…' : isSuper ? 'Abrir Maestros FOOD' : coachPanel ? 'Abrir Seguimiento FOOD' : 'Abrir FOOD PLAN'}
        </button>
        {canFoodFinance && onNavigate ? (
          <button type="button" className="btn-secondary" onClick={() => onNavigate('finance-food')}>
            Finanzas FOOD
          </button>
        ) : null}
      </div>
    </div>
  );
}
